import { ContentLayout, TextContent } from '@amzn/awsui-components-react';
import React from 'react';
import Main from './Main';
import TopHeader from './TopHeader';
import ContainerLayout from './ContainerLayout';
import { useIntl } from 'react-intl';
import styles from './CardContainer.module.css';
import accountlinkConsent from '../i18n/accountlinkConsent.messages';
import Footer from './Footer';
import { AppConfig } from '../types/app';

export const AccountLinkContainer = ({
  config,
  children,
}: {
  config: AppConfig;
  children: React.ReactNode;
}) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <TopHeader config={config} />
      <Main config={config}>
        <ContainerLayout enableResponsiveStyles>
          <ContentLayout>
            <div className={styles.heading_div}>
              <TextContent>
                <h1>{formatMessage(accountlinkConsent.header)}</h1>
              </TextContent>
            </div>
            {children}
          </ContentLayout>
        </ContainerLayout>
      </Main>
      <Footer />
    </>
  );
};
